import { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import ActiveComponentContext from "../../contexts/ActiveComponentContext";

export const useInViewOptions = {
  /* Optional options */
  threshold: 0.25,
  trackVisibility: true,
  delay: 100,
};

export const useComponentInView = () => {
  const { active: activeId, setActive: setActiveComponent } = useContext(
    ActiveComponentContext
  );
  const { ref, entry } = useInView(useInViewOptions);

  useEffect(() => {
    if (entry?.isVisible && entry?.target?.id !== activeId) {
      setActiveComponent(entry.target.id);
    }
  }, [entry, setActiveComponent, activeId]);

  return { ref };
};
